import "core-js/modules/es.array.push.js";
import { debounce } from "lodash";
import { userEditableApps, editCustomAppOrder } from "@/service/appList";
import TextEllipsis from "@/components/Common/text-ellipsis.vue";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
export default {
  name: "app-manage",
  components: {
    TextEllipsis,
    OverflowTooltipText
  },
  data() {
    return {
      menuList: [],
      active: "baseService",
      a: "",
      lock: false,
      lockTimer: null,
      defaultImg: "data:image/svg+xml;charset=UTF-8,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='48' height='48' rx='12' fill='%23785a1a'%3E%3C/rect%3E%3Cpath d='M24 10l2.4 5.6L32 18l-5.6 2.4L24 26l-2.4-5.6L16 18l5.6-2.4L24 10z' fill='%23fff8f1'%3E%3C/path%3E%3Ccircle cx='33' cy='32' r='2.5' fill='%23fff8f1' opacity='0.9'%3E%3C/circle%3E%3Ccircle cx='16' cy='34' r='1.5' fill='%23fff8f1' opacity='0.6'%3E%3C/circle%3E%3Cpath d='M14 24c-1.5 1-2.5 2.8-2.5 4.8' stroke='%23fff8f1' stroke-width='1.5' stroke-linecap='round' opacity='0.5'%3E%3C/path%3E%3C/svg%3E"
    };
  },
  async mounted() {
    await this.getAppLists();
    this.$nextTick().then(() => {
      this.$refs.rightContent.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    goBack() {
      this.$router.push("/MGT");
    },
    async getAppLists() {
      let {
        data: {
          result,
          retVal
        }
      } = await userEditableApps();
      if (result === 0) {
        this.menuList = retVal;
        this.active = retVal[0].id;
      }
    },
    handleScroll(event) {
      const container = event.target;
      let {
        scrollTop,
        scrollHeight,
        clientHeight
      } = container;
      //   console.log(scrollTop, scrollHeight,clientHeight)
      const containerRect = container.getBoundingClientRect();
      const containerCenterY = containerRect.top + container.offsetHeight / 2;
      let closestElement = null;
      let minDistance = Infinity;
      const children = container.querySelectorAll(".child");
      for (const el of children) {
        const elRect = el.getBoundingClientRect();
        const elCenterY = elRect.top + elRect.height / 2;
        const distance = Math.abs(elCenterY - containerCenterY);
        if (distance < minDistance) {
          minDistance = distance;
          closestElement = el;
        }
      }
      if (closestElement && !this.lock) {
        if (scrollTop + clientHeight >= scrollHeight) {
          return this.active = children[children.length - 1].id;
        }
        if (scrollTop <= 0) {
          return this.active = children[0].id;
        }
        this.active = closestElement.id;
      }
    },
    setLock() {
      clearTimeout(this.lockTimer);
      this.lockTimer = null;
      //   console.log("上锁");
      this.lock = true;
      this.lockTimer = setTimeout(() => {
        // console.log("解锁");
        this.lock = false;
      }, 1000);
    },
    scrollTo(id) {
      debounce(() => {
        const element = this.$refs[id][0];
        this.setLock();
        element.scrollIntoView({
          behavior: "smooth"
        });
        this.active = id;
      }, 100)();
    },
    choice(app) {
      this.$router.push({
        name: "app-detail",
        query: {
          ...app
        }
      });
      // this.$refs.selectedModalRef.open(app);
    },
    async change(data, list) {
      const {
        element: {
          id
        },
        newIndex
      } = data.moved;
      const toAppId = list[newIndex + 1].id;
      const data1 = {
        fromAppId: id,
        toAppId
      };
      const {
        data: {
          result,
          msg
        }
      } = await editCustomAppOrder(data1);
      if (result !== 0) {
        this.$Message.error(msg);
      }
    }
  }
};